






















































import {
  Vue, Component, Prop, PropSync, Watch,
} from 'vue-property-decorator';
import Card from '@/components/Card/StandardCard/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import SystemModule from '@/store/modules/system';

import Dropdown from '@/components/Form/Dropdown/index.vue';
import { SettingsApi } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
@Component({
  components: {
    Card,
    PrimaryButton,
    TextButton,
    Dropdown,
  },
})
export default class ActiveEvents extends Vue {
  public edit: boolean = false;

  public threshold: Array<string> = []

  get daySelection() {
    const days = [];
    for (let i = 1; i < 8; i += 1) {
      days.push(i);
    }
    return days;
  }

  get thresholdValue() {
    return this.currentThreshold;
  }

  // set thresholdValue(v) {
  //   this.threshold.push(String(v));
  // }

  get activeThreshold() {
    return this.daySelection.find(el => el === Number(this.currentThreshold[0]));
  }

  set activeThreshold(v) {
    if (v) {
      this.threshold = [];
      this.threshold.push(String(v));
    }
  }

  get currentThreshold() {
    return SystemModule.activeEventThreshold;
  }

  private thresholdUnchanged(): boolean {
    const next = this.threshold.map(String);
    const prev = this.currentThreshold.map(String);
    return next.length === prev.length && next.every((v, i) => v === prev[i]);
  }

  public async close() {
    if (this.threshold.length === 0 || this.thresholdUnchanged()) {
      this.edit = false;
      return;
    }
    const payload: any = {
      activeEventThreshold: this.threshold,
    };
    const settingsApi = new SettingsApi(AppModule.apiConfig);
    const updatedSettings = (await settingsApi.patchSettings(payload)).data;
    SystemModule.SET_SETTINGS(updatedSettings);
    this.edit = false;
  }
}
